import MultiStepForm from '@/components/forms/MultiStepForm';
import GeneralUserSubscriptions from '@/components/forms/apps/GeneralUserSubscriptions';
import RedirectUriForm from '@/components/forms/apps/RedirectUriForm';
import TodoConfigForm from '@/components/forms/apps/todo/TodoConfigForm';
import WeclappInterfaceForm from '@/components/forms/apps/WeclappInterfaceForm';
import TanssInterfaceForm from '@/components/forms/apps/TanssInterfaceForm';
import tenant from '@/services/TenantService';
import { toast } from 'react-toastify';
import ToastMessage from '@/components/toasts/ToastMessage';

export default function TodoSetup({ app, onFinish, onCancel, deployment }) {
  const depl = deployment || {};
  const steps = [
    <TodoConfigForm key="todoConfig" app={app} />,
    <WeclappInterfaceForm key="weclappInterface" app={app} />,
    <TanssInterfaceForm key="tanssInterface" app={app} />,
    <RedirectUriForm key="redirectUri" app={app} />,
    <GeneralUserSubscriptions key="userSubcriptions" app={app} />,
  ];

  const handleSubmit = async (formData, users) => {
    const { redirectUri, ...configData } = formData;
    const deploymentData = {
      app: app._id,
      config: configData,
      redirectUri,
    };

    try {
      const deploymentResponse = await tenant.put(
        `/deployment/${depl.insertedId}`,
        deploymentData,
      );
      const { deployment } = deploymentResponse.data;

      await tenant.post('/subscription', {
        userIds: users,
        deploymentId: depl.insertedId,
      });

      onFinish(deployment, users);
    } catch (error) {
      toast.error(
        <ToastMessage
          title="Fehler"
          subtitle={
            error?.response?.data?.message ||
            'Fehler beim Erstellen der Konfiguration'
          }
        />,
      );
    }
  };

  return (
    <MultiStepForm steps={steps} onSubmit={handleSubmit} onCancel={onCancel} />
  );
}
